<template>
  <div class="header-outer">
    <span class="header-title">韶关市农村集体“三资”大数据</span>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped lang="scss">
.header-outer{
  line-height: 74px;
  text-align: center;
  background: url('~@/assets/images/bg_title.png') center center  no-repeat;
  .header-title{
    font-size: 32px;
    color: var(--color);
    letter-spacing: 3px;
  }
}
</style>
